import Vue from "vue";
import request from "@/utils/request";
import App from "./App.vue";
import "./assets/css/style.css";
import filters from "@/filter";
Vue.use(filters);
Vue.config.productionTip = false;

// //本地测试
// const baseURL = "http://127.0.0.1:5000/";
// const accessLog = "http://localhost:5135/api/IMAPI/";

//本地测试
// const baseURL = "http://192.168.10.129:5000/";
// const accessLog = "http://192.168.10.129:5135/api/IMAPI/";

// 测试环境
// const baseURL = "http://im2server-dev.jinlaijinwang.com/";
// const accessLog = "http://im2aics-dev.jinlaijinwang.com/api/IMAPI/";

// // 外网
const baseURL = "https://im2server.jinlaijinwang.com/";
const accessLog = "https://im2aics.jinlaijinwang.com/api/IMAPI/";

request.defaults.baseURL = baseURL;
Vue.prototype.$baseURL = baseURL;
Vue.prototype.$accessLog = accessLog;
//Vue.prototype.$dev_id = dev_id;

new Vue({
    render: h => h(App)
}).$mount("#jljw_IM_GdImBox");